import { FC, ReactNode } from "react";
import messages from './messages.json'
import { Typography, TypographyProps } from "@mui/material";



export interface Props extends TypographyProps {
    content?: keyof typeof messages;
}

const Message: FC<Props> = ({ content, ...props }) => {
    let node: ReactNode = null;
    if (content) {
         node = messages[content] ?? content
    }

    return (
        <Typography {...props} dangerouslySetInnerHTML={{ __html: node as string }} />
    );
}

export default Message;